import GqlData from "../gql_data";

const liveStreamQuery = (id: number): GqlData => {
    return {
        query: `query liveStream($id: Int!)
            {
                liveStream (id: $id) {
                    id title url
                }
            }`,
        variables: { id }
    }
};

export { liveStreamQuery }